import { USE_MOCK_API } from './httpClient'
import * as mock from './links.mock'
import * as http from './links.http'

const impl = USE_MOCK_API ? mock : http

export const listLinks = impl.listLinks
export const addLink = impl.addLink
export const updateLink = impl.updateLink
export const deleteLink = impl.deleteLink
